export default __webpack_public_path__ + "static/business-address-690befc2ac8f48cc43644e677be44227.webp";